import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {I18nStringItem} from '@tj/tj-dmp-lib-api';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dmp-table-i18n',
    templateUrl: './table-i18n.component.html',
    styleUrls: ['./table-i18n.component.scss'],
    providers: [ConfirmationService],
    standalone: false
})
export class TableI18nComponent implements OnInit {
    @Input() readonly = true;
    @Input() enablePasteKey = true;
    @Input() traductions: I18nStringItem[];
    @Input() cols: SelectItem[];
    @Output() colsChange = new EventEmitter<SelectItem[]>();
    @Output() pasteKey = new EventEmitter<string>();
    // _selectedColumns: any[];
    frozenCols: any[];

    constructor(private confirmationService: ConfirmationService,
                private translate: TranslateService) {

    }

    ngOnInit(): void {
        if (this.cols == null || this.cols.length === 0) {
            if (this.traductions && this.traductions.length > 0 && this.traductions[0].values) {
                this.cols = Object.keys(this.traductions[0].values).map(v => ({value: v}));
            } else {
                this.cols = [];
                ['FR', 'EN', 'IT', 'DE', 'NL', 'ES'].forEach(lg =>
                    this.cols.push({value: lg})
                );
            }
            this.colsChange.emit(this.cols);
            // this._selectedColumns = [...this.cols];
        }
    }

    public getValue(): I18nStringItem[] {
        return this.traductions;
    }

    addLang(): void {
        const langTxt = prompt('Indiquer le code de la langue');
        const lang = {value: langTxt.trim().toUpperCase()};
        if (lang.value.length > 1) {
            const lang = {value: langTxt.trim().toUpperCase()};
            this.cols.push(lang);
            this.traductions.forEach((traduction) => {
                traduction.values[lang.value] = '';
            });
        }
        this.colsChange.next(this.cols);
    }

    addLine(): void {
        let value = prompt(
            `Nom de votre clé de traduction`
        );
        if (value && value.trim().length > 0) {
            value = value.split(' ').join('_');
            value = value.split('.').join('_');
            if (this.traductions == null) {
                this.traductions = [];
            }
            const traduction: I18nStringItem = {
                key: value,
                values: {},
            };
            this.cols.forEach((col) => {
                traduction.values[col.value] = '';
            });
            this.traductions.push(traduction);
        }

    }

    restrictKeyI18n(e) {
        if (e.metaKey || e.ctrlKey) {
            return false;
        }
        // espace
        if (e.which === 32) {
            return false;
        }
        if (e.which === 0) {
            return false;
        }
        if (e.which < 33) {
            return true;
        }
        return true;
    }

    removeCol(col: SelectItem, event) {
        this.confirmationService.confirm({
            target: event.target,
            key: 'i18n-dialog',
            message: this.translate.instant('common.confirm'),
            acceptLabel: this.translate.instant('common.True'),
            rejectLabel: this.translate.instant('common.False'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.cols = this.cols.filter((c) => c.value != col.value);
                this.traductions.forEach((traduction) => {
                    delete traduction.values[col.value];
                });
            },
            reject: () => {
                // not yet
            }
        });
    }

    removeLine(line: I18nStringItem, event) {
        this.confirmationService.confirm({
            target: event.target,
            key: 'i18n-dialog',
            message: this.translate.instant('common.confirm'),
            acceptLabel: this.translate.instant('common.True'),
            rejectLabel: this.translate.instant('common.False'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.traductions = this.traductions.filter(t => t.key !== line.key);
            },
            reject: () => {
                // not yet
            }
        });
    }

    paste(key: string) {
        this.pasteKey.emit(key);
    }
}
